import React from "react";
import { Environment, environmentSettings } from "./environments";

export const useImpersonationAccessToken = (props: {
  accessToken: string;
  subjectId: string | null | undefined;
  clientId: string;
  environment: Environment;
  skip?: boolean;
}) => {
  const [state, setState] = React.useState<{
    accessToken?: string;
    error?: string;
    loading?: boolean;
  }>({});

  const shouldFetch = !props.skip && !!props.subjectId;

  React.useEffect(() => {
    let aborted = false;

    (async () => {
      if (!shouldFetch) {
        return;
      }

      var data = new FormData();
      data.append("subject_id", props.subjectId!);
      data.append("grant_type", "impersonation");
      data.append("client_id", props.clientId);
      data.append("actor_token", props.accessToken);

      try {
        const response = await fetch(
          environmentSettings[props.environment].url + "/connect/token",
          {
            method: "POST",
            body: data
          }
        );

        if (aborted) {
          return;
        }

        if (response.status >= 400) {
          setState({ error: "impersonation_failed" });
          return;
        }

        var responseData = await response.json();

        if (aborted) {
          return;
        }

        setState({
          accessToken: responseData.access_token
        });
      } catch (error) {
        if (aborted) {
          return;
        }

        setState({ error: "network_error" });
      }
    })();

    return () => {
      aborted = true;
    };
  }, [props.accessToken, props.subjectId, props.skip, props.clientId, props.environment, shouldFetch]);

  // Set state directly to avoid bugs when loading is switched later in effect
  const previousSubjectId = React.useRef<string | null>();
  if (props.subjectId !== previousSubjectId.current) {
    previousSubjectId.current = props.subjectId;
    setState({
      loading: shouldFetch
    });
  } else if (state.loading && !shouldFetch) {
    setState({
      loading: false
    });
  }

  return state;
};
